import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useProfiles } from '../_load/ProfilesLoader'
import { useSavePermissions } from './_requests/savePermissions'
import Link from '../../../../packages/kiti/components/actions/Link'
import Loading from '../../../../packages/kiti/components/helpers/Loading'
import Text from '../../../../packages/kiti/components/presentation/Text'

const PermissionActions = ({ name }) => {
  const { t } = useTranslation('editPermissions')
  const profiles = useProfiles()

  const [save, { loading }] = useSavePermissions()

  const handleSave = enabled => {
    const inputs = profiles.map(profile => ({
      enabled,
      profileId: profile.id,
      name
    }))
    save(inputs)
  }

  if (loading) return <Loading />

  return (
    <Grid justify="center" align="center" direction="row" gutter={0.15}>
      <Col>
        <Link onClick={() => handleSave(true)}>
          <Text color="green" size="xxsmall" bold>
            {t('enable')}
          </Text>
        </Link>
      </Col>
      <Col>
        <Link onClick={() => handleSave(false)}>
          <Text color="red" size="xxsmall" bold>
            {t('disable')}
          </Text>
        </Link>
      </Col>
    </Grid>
  )
}

export default PermissionActions
